import { useEffect, useState } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { Trans } from 'react-i18next';
import GraphGlobalSkillsSummary from "./GraphGlobalSkillsSummary";
import { GlobalSkillsSummaryModel } from 'src/models/businessManager/businessManager.model';
import IconButton from 'src/components/Button/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';
import { Refresh } from "@mui/icons-material";

function GlobalSkillsSummary(props) {
    const { t } = useTranslation();
    const idBusinessManager = props.idBusinessManager;
    const [globalSkillsSummary, setGlobalSkillsSummary] = useState<GlobalSkillsSummaryModel[]>(props.data);

    const getObjectifMaturityValue = (data: GlobalSkillsSummaryModel) => {
        if (idBusinessManager == 1) {
            return data.bmObjectifMaturity
        } else if (idBusinessManager == 2) {
            return data.sbmObjectifMaturity
        } else if (idBusinessManager == 3) {
            return data.bumObjectifMaturity
        } else if (idBusinessManager == 4) {
            return data.sbumObjectifMaturity
        } else if (idBusinessManager == 5) {
            return data.budObjectifMaturity
        } else if (idBusinessManager == 6) {
            return data.sbudObjectifMaturity
        } else { return null }
    }

    useEffect(() => {
        setGlobalSkillsSummary(props.data);
    }, [props.data]);

    useEffect(() => {
        setGlobalSkillsSummary(all =>
            all.map(data => {
                data.objectifMaturity = getObjectifMaturityValue(data)
                return data;
            })
        );
    }, [idBusinessManager]);

    return (
        <>
            <div style={{ textAlign: 'right' }}>
                <IconButton
                    variant="contained"
                    color="primary"
                    title={t('eepBm.tableSummary.refresh')}
                    margin={5}
                    width={36.5}
                    icon={<Refresh style={{ fontSize: 20 }} />}
                    onClick={props.refreshData}
                    disabled={props.isVisu}
                />
            </div>
            <TableContainer style={{ marginTop: 5 }} component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell align="center"><Trans>eepBm.tableSummary.title1</Trans></TableCell>
                            <TableCell align="center"><Trans>eepBm.tableSummary.title2</Trans></TableCell>
                            <TableCell align="center"><Trans>eepBm.tableSummary.title3</Trans></TableCell>
                            <TableCell align="center"><Trans>eepBm.tableSummary.title4</Trans></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {globalSkillsSummary.map((row) => (
                            <TableRow key={row.idSkillCategoryType} style={{ height: 40 }}>
                                <TableCell component="th" scope="row" style={{ paddingLeft: 10 }}><b>{row.skillCategTypeName}</b></TableCell>
                                <TableCell align="center">{row.objectifMaturity}</TableCell>
                                <TableCell align="center">{row.employeeVision}</TableCell>
                                <TableCell align="center">{row.managerVision}</TableCell>
                                <TableCell align="center">{row.difference}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div style={{ textAlign: 'center', marginTop: 15 }}>
                <Paper >
                    <GraphGlobalSkillsSummary data={globalSkillsSummary} />
                </Paper>
            </div>
        </>
    );
}

export default GlobalSkillsSummary;